import { FeatureFlagKey } from "encamp-shared/src/featureFlags";
import { useFeatureFlags } from "hooks/useFeatureFlags";

import { FacilityProfile } from "./FacilityProfile";
import { FacilityProfileV2 } from "./FacilityProfileV2";

export const FacilityProfileSwitch: React.FC = () => {
  const { featureFlags } = useFeatureFlags();

  if (featureFlags?.[FeatureFlagKey.FacilityProfileV2]) {
    return <FacilityProfileV2 />;
  }

  return <FacilityProfile />;
};
